module.exports = __webpack_public_path__ + "static/media/land_rood.6f0340b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_rood.svg
// module id = 610
// module chunks = 0